export default __webpack_public_path__ + "static/media/ganarbolt.f39d4094.svg";